var _style, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5AC8FA;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "oval",
    className: "st0",
    cx: 32,
    cy: 32,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    className: "st1",
    d: "M28.3,43.5c0.5,0.4,1.1,0.6,1.8,0.4c0.6-0.1,1.2-0.5,1.6-1l0,0l12.7-18.6c0.4-0.6,0.6-1.2,0.4-1.9 c-0.1-0.7-0.5-1.2-1-1.6c-0.5-0.4-1.1-0.6-1.8-0.4c-0.6,0.1-1.1,0.5-1.5,1l0,0L29.4,37.6L23.3,31c-0.5-0.5-1-0.8-1.7-0.8 c-0.7,0-1.2,0.2-1.7,0.7s-0.7,1.1-0.7,1.8c0,0.7,0.2,1.3,0.7,1.8l0,0l1.9,2.1c1.2,1.4,2.5,2.8,3.9,4.3C27.1,42.4,28,43.2,28.3,43.5z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2e9b946e3ea412eaf47736a0ebb1e664.svg";
export { ForwardRef as ReactComponent };